<script>
export default {
  name: 'CreditPaymentForm',
  props: {
    formData: {
      card_number: String,
      titular_name: String,
      card_month: Number,
      card_year: Number
    }
  },
  data: function () {
    return {
      form: this.formData
    };
  },
  methods: {
    validForm: async function () {
      return this.$refs.validationObserver.validate();
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    }
  }
};
</script>

<template>
  <ValidationObserver ref='validationObserver'>
    <div class="new-form-row">
      <p class="new-form-text">Dados de pagamento:</p>
    </div>
    <div class="new-form-row">
      <validation-provider vid="card_number" class="new-form-validation" rules='required' v-slot="{ errors }">
        <div class="new-form-input">
          <input type="text" v-mask="'#### #### #### ####'" data-cy="card_number" name="card_number"
            placeholder="Número do cartão" v-model="form.card_number">
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div class="new-form-row">
      <validation-provider vid="titular_name" rules='required' v-slot="{ errors }">
        <div class="new-form-input">
          <input type="text" data-cy="titular" name="titular_name"
            placeholder="Nome do titular do cartão" v-model="form.titular_name">
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div class="new-form-row">
      <validation-provider vid="card_month" rules='required|oneOf:01,02,03,04,05,06,07,08,09,10,11,12' v-slot="{ errors }">
        <div class="new-form-input">
          <select name="card_month" v-model="form.card_month" data-cy="card_month">
            <option disabled value="">Mês de vencimento da validade do cartão</option>
            <option :value="mes" :key="mes" v-for="mes in 12">{{mes}}</option>
          </select>
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div class="new-form-row">
      <validation-provider vid="card_year" rules='required|oneOf:2020,2021,2022,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034' v-slot="{ errors }">
        <div class="new-form-input">
          <select name="card_year" v-model="form.card_year" data-cy="card_year">
              <option disabled value="">Ano de vencimento da validade do cartão</option>
              <option v-for="i in 15" :value="(i+2019)">{{ i+2019 }}</option>
          </select>
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </validation-provider>
    </div>
  </ValidationObserver>
</template>
